import { KeyboardEvent, MouseEvent, useState } from "react";
import { Box, Button, Drawer, IconButton, useMediaQuery } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useAuth } from "swyft-react-core";
import MenuIcon from "@material-ui/icons/Menu";
import { useSelector } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";

import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { useStyles } from "../quoteDetail.styles";
import { PermissionQuoteRead } from "../../../app/consts";
import { RootState } from "../../../app/rootReducer";

interface INavBarState {
  sideMenuOpen: boolean;
  appBarPosition: "static" | "fixed";
}

const Menu = () => {
  const classes = useStyles();
  const { isMoreThanMd } = useBreakpoint();
  const { isAuthenticated, isLoading: authIsLoading, signOut, hasPermission } = useAuth();
  const { quote } = useSelector((state: RootState) => state.quote);

  return (
    <Box
      display={"flex"}
      flexDirection={isMoreThanMd ? "row" : "column"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      {!isMoreThanMd && (
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"} width={"100%"} mb={"20px"}>
          <Link to="/">
            <img className={classes.logo} src={process.env.PUBLIC_URL + "/images/logo.png"} alt="Logo" />
          </Link>
        </Box>
      )}
      <Box mx={"22px"} my={isMoreThanMd ? 0 : "8px"}>
        <Button component={Link} to="/my-quotes" className={classes.navButton}>
          My Quotes
        </Button>
      </Box>
      {isAuthenticated && (
        <Box mx={"22px"} my={isMoreThanMd ? 0 : "8px"}>
          <Button component={Link} to="/quotes" className={classes.navButton}>
            All Quotes
          </Button>
        </Box>
      )}
      {isAuthenticated && hasPermission(PermissionQuoteRead) && quote && (
        <Box mx={"22px"} my={isMoreThanMd ? 0 : "8px"}>
          <Button component={Link} to={`/quote/edit/${quote.id}`} className={classes.navButton}>
            Edit Quote
          </Button>
        </Box>
      )}
      {isAuthenticated && !authIsLoading && (
        <Box mx={"22px"} my={isMoreThanMd ? 0 : "8px"}>
          <Button onClick={() => signOut()} className={classes.navButton}>
            Logout
          </Button>
        </Box>
      )}
    </Box>
  );
};

export const Header = () => {
  const [state, setState] = useState<INavBarState>({
    sideMenuOpen: false,
    appBarPosition: "static"
  });
  const classes = useStyles();
  const { isMoreThanSm, isMoreThanMd } = useBreakpoint();
  const matchesSmallMobile = useMediaQuery("(max-width:360px)");

  const toggleDrawer = (open: boolean) => (event: KeyboardEvent | MouseEvent) => {
    if (
      event.type === "keydown" &&
      ((event as KeyboardEvent).key === "Tab" || (event as KeyboardEvent).key === "Shift")
    ) {
      return;
    }

    setState({
      ...state,
      sideMenuOpen: open,
      appBarPosition: open ? "fixed" : "static"
    });
  };

  return (
    <Box
      py={isMoreThanSm ? "33px" : "24px"}
      px={matchesSmallMobile ? "12px" : 0}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
      bgcolor={!isMoreThanSm ? "#fff" : "transparent"}
    >
      <Link to="/">
        <img className={classes.logo} src={process.env.PUBLIC_URL + "/images/logo.png"} alt="Logo" />
      </Link>
      {isMoreThanMd ? (
        <Menu />
      ) : (
        <Box>
          <IconButton
            edge="start"
            color="secondary"
            aria-label="menu"
            style={{ padding: 0 }}
            onClick={toggleDrawer(!state.sideMenuOpen)}
          >
            {state.sideMenuOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        </Box>
      )}
      {!isMoreThanMd && (
        <Drawer open={state.sideMenuOpen} onClose={toggleDrawer(false)} variant="temporary" anchor="right">
          <Box minWidth={matchesSmallMobile ? "95vw" : "300px"} padding={"20px"}>
            <Menu />
          </Box>
        </Drawer>
      )}
    </Box>
  );
};
